import { URL_SLUG_BY_CARD_TYPE } from '../constants/urlSlugByCardType';
import { CARD_TYPE_MAP, LeadCardType } from '../constants/cardTypes';

/**
 * Gets the SLUG part of a URL for a card type
 *
 * @example
 * getUrlSlugByCardType('SAVE_THE_DATE', false) // 'save-the-date'
 */
export const getUrlSlugByCardType = (
  cardType?: LeadCardType,
  isDigital?: boolean
): string | undefined => {
  const updatedType = isDigital ? CARD_TYPE_MAP.dstd : cardType;
  return (updatedType && URL_SLUG_BY_CARD_TYPE[updatedType]) || undefined;
};

/**
 * Get the base URL for cards with optional admin view
 *
 * @example
 * getBasePlanningUrl(false) // '/wedding-planning'
 *
 * @example
 * getBasePlanningUrl(true) // '/wedding-planning/admin'
 */
export const getBasePlanningUrl = (isAdminView?: boolean) => {
  return isAdminView ? '/wedding-planning/admin' : '/wedding-planning';
};

/**
 * Get the PLP Url for a card type
 *
 * @example
 * getCardPlpPath('SAVE_THE_DATE', false, false) // '/wedding-planning/save-the-date/shop'
 *
 * @example
 * getCardPlpPath('SAVE_THE_DATE', true, false) // '/wedding-planning/admin/save-the-date/shop'
 */
export const getCardPlpPath = (
  cardType: LeadCardType,
  isAdminView?: boolean,
  isDigital?: boolean
) => {
  const urlSlug = getUrlSlugByCardType(cardType, isDigital);
  return `${getBasePlanningUrl(isAdminView)}/${urlSlug}/shop`;
};

/**
 * Gets the URL path to a card suite PDP.
 *
 * @example
 * getCardSuitePath('INVITATION', '8b476596-4a13-4b3e-9b0a-5c149a2da9af', false, false) // '/wedding-planning/invitations/8b476596-4a13-4b3e-9b0a-5c149a2da9af'
 */
export const getCardSuitePath = (
  cardType: LeadCardType,
  suiteUuid: string,
  isAdminView?: boolean,
  isDigital?: boolean
) => {
  const urlSlug = getUrlSlugByCardType(cardType, isDigital);
  return `${getBasePlanningUrl(isAdminView)}/${urlSlug}/${suiteUuid}`;
};
